(ns practitest.frontend.requirements.events
  (:require
   [ajax.core :as ajax]
   [practitest.frontend.common-entities.events :as common-events]
   [practitest.frontend.common-entities.metadata :as metadata]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.grid.events :as grid.events]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.events :as events]
   [practitest.frontend.forms3.entity-form.forms :as forms]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(def requirements-index-state-key (:requirement subs/index-grid-keys))

(re-frame/reg-event-fx
  ::on-testing-scope-change
  (fn [{db :db} [event-id scope hide-event state-key]]
    (let [route (broutes/get-url "requirements#change_testing_scope"
                                 {:p_id (subs/get-current-project-id db)
                                  :id (subs/get-current-entity-id db :requirement)})]
      {:db (update db :progress conj ::on-testing-scope-change)
       :http-xhrio
       {:method          :post
        :uri             route
        :params          {:scope scope}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::on-updating-testing-scope-success hide-event state-key]
        :on-failure      [::on-updating-testing-scope-failed event-id hide-event state-key]}})))

(re-frame/reg-event-fx
  ::on-updating-testing-scope-success
  (fn [{:keys [db]} [_ hide-event state-key response]]
    {:db db
     :fx [[:dispatch [::on-testset-linked response]]
          [:dispatch [hide-event state-key]]]}))

(re-frame/reg-event-db
  ::on-testset-linked
  (fn [db [_ response]]
    (let [{:keys [entity traceability]} response
          entity-type :requirement
          form-id (get-in metadata/entities-metadata [entity-type :form-id])]
    (-> db
        (update :progress disj ::on-testing-scope-change)
        (assoc-in [:entity entity-type :current] (assoc entity :type entity-type))
        (assoc-in [:entity entity-type :traceability] traceability)
        (forms/reconcile-form-state form-id false entity-type entity)))))

(re-frame/reg-event-fx
  ::on-updating-testing-scope-failed
  (fn [{:keys [db]} [_ event-id hide-event state-key]]
    (let [message (get-translation "requirement.notify.error-linking-testset" 
                                   "Error linking Test Set to Requirement")]
      {:db (update db :progress disj event-id)
       :fx [[:dispatch [::events/api-error event-id {:message message}]]
            [:dispatch [hide-event state-key]]]})))

(re-frame/reg-event-db
  ::set-testset-selection
  (fn [db [_ state-key linked-ids]]
    (assoc-in db [:entity :requirement state-key :selection] linked-ids)))

(re-frame/reg-event-fx
  ::open-link-testset-modal
  (fn [{:keys [db]} [_ state-key]]
    {:fx [[:dispatch [::common-events/toggle-link-entities-modal
                      :testset
                      state-key
                      ::common-events/fetch-entity-list
                      (reagent/partial grid-storage/load-per-page :testset)]]]}))
